import { assertIsUUID } from '../assertions';

/**
 * The UUID class value property represents the UUID V4 format as a string type
 *
 * @see {@link https://en.wikipedia.org/wiki/Universally_unique_identifier} for more information
 */
export default class UUID {
	public get value(): string {
		return this.#value;
	}

	#value: string;
	public constructor(value: string) {
		assertIsUUID(value);
		this.#value = value;
	}
}
